/**
 * Created by josh on 2017/8/11.
 */

import ButtonGroup from '../button/src/button-group.vue';

/* istanbul ignore next */
ButtonGroup.install = function(Vue) {
    Vue.component(ButtonGroup.name, ButtonGroup);
};

export default ButtonGroup;


// WEBPACK FOOTER //
// ./src/plugin-api/packages/button-group/index.js